import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const BootStrap = () => {
  return (
    <StartInterviewLayout type="bootstrap"/>
  )
}

export default BootStrap;